import { Modal } from 'components/molecules'
import { useActions, useAppState } from 'presenter'
import { useState } from 'react'
import { TaskEditor } from '../TaskEditor/TaskEditor'
import { ModalLeaveWarning } from './ModalLeaveWarning'

export const CreateNewTaskModal = () => {
  const { currentModal, isCreateNewTaskFormDirty, selectedTaskDetails } = useAppState()
  const { displayModalAction, setIsCreateNewTaskFormDirty } = useActions()
  const [closing, setClosing] = useState<boolean>(false)

  const onClose = async () => {
    setClosing(true)
    if (isCreateNewTaskFormDirty) return setIsCreateNewTaskFormDirty(true)
    displayModalAction('None')
  }

  const onCancel = () => displayModalAction('None')

  return (
    <Modal
      isOpen={currentModal === 'CreateNewTaskModal'}
      shouldCloseOnEsc
      onClose={onClose}
      contentStyle={{
        width: '550px',
      }}
    >
      <div className='h-[calc(100vh-80px)]'>
        <TaskEditor
          mode='Create'
          task={selectedTaskDetails}
          onSaved={(shouldClose) => shouldClose ? onCancel() : undefined}
        />
        <ModalLeaveWarning
          onClickNo={() => setClosing(false)}
          onClickYes={onCancel}
          show={isCreateNewTaskFormDirty && closing}
        />
      </div>
    </Modal>
  )
}
